// COMPONENTS
import OpenPartForm from "../../forms/parts/openPart/openPart.form";
import Modal from "../../modals/modal.component";
import DefaultButton from "../default.button";
import { ReactComponent as PlusIcon } from "../../../assets/icons/add.icon.svg";
// HOOKS
import useModal from "../../../hooks/other/useModal.other.hook";

const CreateOpenPartButton = () => {
  const { isShowing, open, close } = useModal();
  return (
    <>
      <Modal isOpen={isShowing} onClose={close}>
        <div className="w-full h-full flex justify-center items-center">
          <OpenPartForm />
        </div>
      </Modal>
      <DefaultButton handleClick={open}>
        <div className="flex flex-row gap-1">
          <PlusIcon className="fill-white" />
          <span>Part Request</span>
        </div>
      </DefaultButton>
    </>
  );
};

export default CreateOpenPartButton;
